import React from "react";
import "./ManageTask.css";

export const ManageTask = () => {
	return <div className='ManageTask'>ManageTask</div>;
};
